<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <textarea [(ngModel)]="message" [placeholder]="initialMessage" rows="5"></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="submit()" class="btn btn-dark button-large" type="submit">{{ buttonLabel }}</button>
</div>

